import { Link, useLocation } from "react-router-dom";
import { CAL_BOOKING_URL } from "@/lib/constants";

export const Header = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#F3ECDD]/80 border-b border-[#DAD0BA]/50"
    >
      <div className="max-w-6xl mx-auto px-6 py-2 flex items-center gap-10">
        <Link to="/" data-testid="logo-link" className="flex items-center">
          <img src="/inalign-logo.png" alt="InAlign Wellness logo" className="h-28 w-auto object-contain" />
        </Link>
        <nav className="flex items-center gap-7">
          <a href="/#services" data-testid="nav-services" className="hidden sm:inline text-sm font-semibold text-[#5C5848] hover:text-[#556B2F] transition-colors">
            Services
          </a>
          <a href="/#about" data-testid="nav-about" className="hidden sm:inline text-sm font-semibold text-[#5C5848] hover:text-[#556B2F] transition-colors">
            About
          </a>
          <a href="/#testimonials" data-testid="nav-reviews" className="hidden sm:inline text-sm font-semibold text-[#5C5848] hover:text-[#556B2F] transition-colors">
            Reviews
          </a>
          <a href="/#results" data-testid="nav-results" className="hidden sm:inline text-sm font-semibold text-[#5C5848] hover:text-[#556B2F] transition-colors">
            Results
          </a>
          <a href="/#guide" data-testid="nav-guide" className="hidden sm:inline text-sm font-semibold text-[#5C5848] hover:text-[#556B2F] transition-colors">
            Free Guide
          </a>
          <a
            href={CAL_BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-book-button"
            className="ml-auto bg-[#556B2F] hover:bg-[#44531F] text-white rounded-full px-8 py-3.5 text-base font-bold shadow-sm transition-colors whitespace-nowrap"
          >
            Book a Discovery Call
          </a>
        </nav>
      </div>
    </header>
  );
};
